<template>
    <v-dialog width="450px" v-model="dialog">

        <template v-slot:activator="{ on }">
            <v-btn v-on="on" outlined class="rounded-pill mr-3" :disabled="INTERVAL_DAY == intervalId">
                <v-icon small left>mdi-content-copy</v-icon>
                Copy Shifts
            </v-btn>
        </template>

        <v-card v-if="dialog">
            <v-card-title>
                <span class="headline">Copy shifts from: {{ shiftsRangeText }}</span>
                <v-spacer></v-spacer>
                <v-icon @click="dialog = false">mdi-close</v-icon>
            </v-card-title>

            <v-card-text>
                <div class="mb-3">Please select period where to copy current shifts:</div>

                <v-date-picker v-model="date_range_selected" scrollable full-width first-day-of-week="1" range
                    :title-date-format="dateRangeText" @click:date="dateRangeSelect" />

                <v-switch v-model="keep_driver" label="Keep assigned drivers" class="mt-3" />
            </v-card-text>

            <v-card-actions class="justify-center pb-4">
                <v-btn depressed color="primary" class="mr-4" :disabled="localLoading || isShiftsEmpty"
                    :loading="localLoading" @click="submit">
                    <v-icon left>mdi-content-copy</v-icon>
                    Make Copy of Shifts
                </v-btn>
                <v-btn color="warning" depressed :loading="localLoading" @click="dialog = false">
                    <v-icon left>mdi-cancel</v-icon>
                    Cancel
                </v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>
import moment from 'moment'
import * as _ from 'lodash'
import {
    DATE_RANGE_HELPERS,
    INTERVAL_DAY,
} from '@/store/shifts'

export default {
    name: "DriverShareCopyScheduleModal",

    props: {
        shiftGroups: { type: Array, required: true },   // drivershareShifts (shift group records)
        intervalId: { type: Number, required: true },
        dateRangeSelected: { type: Array, default: () => [] } // currently viewed [start, end]
    },

    data() {
        return {
            dialog: false,
            localLoading: false,
            date_range_selected: null,
            keep_driver: true,
            INTERVAL_DAY,
        }
    },

    created() {
        // Initialise picker to the currently viewed range (same as original)
        this.date_range_selected = this.dateRangeSelected
    },

    watch: {
        dialog(val) {
            if (!val) return
            this.date_range_selected = this.dateRangeSelected && this.dateRangeSelected[0]
                ? [...this.dateRangeSelected]
                : [moment().startOf('isoWeek').format('YYYY-MM-DD'), null]

            this.dateRangeSelect()
        }
    },

    computed: {
        isShiftsEmpty() {
            return _.isEmpty(this.shiftGroups)
        },

        shiftsRangeText() {
            if (this.isShiftsEmpty) return 'no shifts'

            const range = this.dayToRange(this.dateRangeSelected, this.intervalId)
            return DATE_RANGE_HELPERS.dateRangeText(range)
        }
    },

    methods: {
        submit() {
            this.localLoading = true

            const ids = this.shiftGroups.map(g => g.id)

            console.log('[CopyModal] submitting:', {
                shift_group_ids: ids,
                to_date: this.date_range_selected[0],
                keep_driver: this.keep_driver
            })

            this.$store.dispatch('copyDrivershareShifts', {
                shift_group_ids: ids,
                to_date: this.date_range_selected[0],
                keep_driver: this.keep_driver
            })
                .then(() => {
                    this.dialog = false
                    this.$emit('copied')
                })
                .finally(() => {
                    this.localLoading = false
                })
        },

        dateRangeSelect() {
            if (!this.date_range_selected || !this.date_range_selected[0]) return
            this.date_range_selected = this.dayToRange(
                this.date_range_selected[0],
                this.intervalId
            )
        },

        dayToRange(date, interval_id) {
            return DATE_RANGE_HELPERS.dayToRange(date, interval_id)
        },

        dateRangeText(date_range_selected) {
            return 'to: ' + DATE_RANGE_HELPERS.dateRangeText(date_range_selected)
        }
    }
}
</script>

<style scoped>
.headline {
    font-weight: 600;
}
</style>